import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { getDynamicMapElementName } from "../../helper/displayHelpers";
import { MenuCardLabel } from "../menu/MenuCardLabel";
import { MenuCard } from "../menu/MenuCard";
import { MenuCardScrollContainer } from "../menu/MenuCardScrollContainer";
import { undoableMapEditorSelectTile } from '../../stores/undo/operation/MapEditorEntitySelectionOp';
import { AdvancedListItem } from "../shared/AdvancedListItem";
import { DynamicMapElementChangeGroup, groupUndoableMapEditorDynamicMapElementChanges } from '../../stores/undo/operation/MapEditorSubmitCurrentMapDynamicMapElementsChangesOp';
import { mainMapEditorStore } from '../../stores/MapEditorStore';
import { getIconForElementPartOfText } from '../../helper/mapElementIconHelper';
const ScrollContainer = styled(MenuCardScrollContainer).withConfig({
  displayName: "ObjectNavigator__ScrollContainer",
  componentId: "sc-go95pf-0"
})(["max-height:300px;"]);
export const ObjectNavigator = observer(() => {
  const {
    currentMap,
    isUserAllowedToEditCurrentMap
  } = mainMapEditorStore.currentMapStore;
  const {
    t
  } = useTranslation();

  function onSelect(element) {
    undoableMapEditorSelectTile(element.position, mainMapEditorStore, true);
  }

  function deleteElement(element) {
    groupUndoableMapEditorDynamicMapElementChanges(DynamicMapElementChangeGroup.Delete, () => {
      currentMap.removeDynamicMapElement(element);
    });
  }

  return /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(MenuCardLabel, null, t("editor.objects")), currentMap.dynamicMapElements.length > 0 && /*#__PURE__*/React.createElement(ScrollContainer, null, currentMap.dynamicMapElements.map(element => /*#__PURE__*/React.createElement(AdvancedListItem, {
    key: element.$modelId,
    itemObject: element,
    icon: getIconForElementPartOfText(element),
    itemName: getDynamicMapElementName(element, true),
    itemId: -1 // not needed in this case
    ,
    isSelected: mainMapEditorStore.isSelectedTilePosition(element.position),
    onSelectItem: onSelect,
    onConfirmDelete: () => {
      deleteElement(element);
    },
    deleteWithoutConfirmation: true,
    allowDeletion: isUserAllowedToEditCurrentMap
  })), currentMap.interactionTriggerTiles.map(tile => /*#__PURE__*/React.createElement(AdvancedListItem, {
    key: tile.$modelId,
    itemObject: tile,
    icon: getIconForElementPartOfText(tile),
    itemName: tile.interactionTriggerData.label || "",
    itemId: -1 // not needed in this case
    ,
    isSelected: mainMapEditorStore.isSelectedTilePosition(tile.position),
    onSelectItem: onSelect,
    onConfirmDelete: undefined,
    i18nKeyDeleteModalMessage: undefined,
    i18nKeyDeleteModalTitle: undefined,
    allowDeletion: isUserAllowedToEditCurrentMap
  }))));
});